/*
 * Copyright (c) 2012 Macrofocus GmbH. All Rights Reserved.
 */
package org.mkui.graphics.pressure

import kotlin.math.log10

class LogPressure : Pressure {
    override fun transform(v: Double): Double {
        return log10(v)
    }
}